import type { EasingType } from '@visactor/vrender-core';

export const DefaultAxisAnimation = {
  type: 'default',
  duration: 300,
  easing: 'linear' as EasingType
};
